import { render, staticRenderFns } from "./ProductFormatNormalised.vue?vue&type=template&id=7dc96e3e&"
import script from "./ProductFormatNormalised.vue?vue&type=script&lang=js&"
export * from "./ProductFormatNormalised.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports